
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";

import _ from "lodash-es";
@Component({})
export default class Step1 extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  title = "admin配置";

  created() {
    //
  }
  mounted() {
    const a = this.exam;
    console.log(a);
  }

  async ok() {
    //todo 一些校验可以在这里做
    await this.checkData();

    // this.$emit("ok", "xxx");
  }

  //关闭
  close() {
    this.$emit("close", "xxx");
  }
  //离开前校验
  async checkData() {
    return new Promise((resolve, reject) => {
      //do something
      resolve(true);
      // reject(false);
    });
  }
}
